// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2143) return "css/styles.9612a1cd.css";
	// return url for filenames based on template
	return "css/" + chunkId + ".styles." + {"2189":"002f2030","2283":"41aab973"}[chunkId] + ".css";
};